import { render } from "./footer.layout.vue?vue&type=template&id=02f1217b"
import script from "./footer.layout.vue?vue&type=script&lang=js"
export * from "./footer.layout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__